import { axiosInstance } from '@/shared/api/axios';
import { ErrorCode } from '@/shared/constants/error';
import { OverseasInvestigationAuthUrlGetResponseType } from '@/shared/types/api/api.overseasInvestigation';

/**
 * 海外調査認証URL取得API
 * G-Search海外検索サービスへのワンタイムID認証URLを取得する
 */
export const getOverseasInvestigationAuthUrl = async (
  groupId: number,
): Promise<OverseasInvestigationAuthUrlGetResponseType> => {
  const { data } = await axiosInstance.get<OverseasInvestigationAuthUrlGetResponseType>(
    `/group/${groupId}/overseas-investigation/auth-url`,
    {
      errorMessages: [
        { code: ErrorCode.ERROR_OVERSEAS_INVESTIGATION_NOT_SUBSCRIBED, type: 'reject' },
        { code: ErrorCode.ERROR_OVERSEAS_INVESTIGATION_PLAN_NOT_ALLOWED, type: 'reject' },
      ],
    },
  );
  return data;
};
